import React from 'react'
import { Flex } from '@chakra-ui/react'

const PageLabel = props => {
  return (
    <Flex
      alignItems="center"
      backgroundColor="white"
      borderColor="gray.200"
      borderRadius="base"
      borderStyle="solid"
      borderWidth={1}
      flexWrap="no-wrap"
      justifyContent="space-between"
      px={3}
      py={2}
      _hover={{
        'svg.fa-chevron-right': {
          transform: 'translateX(5px)',
          transitionProperty: 'transform',
          transitionDuration: '0.15s',
        },
      }}
      {...props}
    >
      {props.children}
    </Flex>
  )
}

export default PageLabel
